import { useTranslation } from 'react-i18next';

import { useAuthContext } from '@myphx-engineering/auth/client';
import {
    IconApprovalDelegation,
    IconBadge,
    IconFavorite,
    IconMedication,
    SideNavLink,
} from '@myphx-engineering/phx-design-system';

import { usePatientContext } from '../../../hooks/use-patient-context';
import { getAbsoluteRoute } from '../../../util';
import { ConditionalComponent } from '../../utility/ConditionalComponent';
import { MenuSection } from '../MenuSection';

export const MyAccountSection = () => {
    const { t } = useTranslation();

    const { isAuthenticated } = useAuthContext();
    const { preferences, patient } = usePatientContext();
    const { favoritePharmacies } = preferences;

    return (
        <ConditionalComponent condition={isAuthenticated}>
            <MenuSection label={t('sidebar.myAccount.heading')}>
                <SideNavLink
                    label={t('sidebar.myAccount.medCab')}
                    Icon={IconMedication}
                    href={getAbsoluteRoute('cabinet.root')}
                />
                <SideNavLink
                    label={t('sidebar.myAccount.benefitCard')}
                    Icon={IconBadge}
                    href={getAbsoluteRoute('profile.benefit')}
                />
                <ConditionalComponent condition={!!patient?.hasPbmPlan}>
                    <SideNavLink
                        label={t('sidebar.myAccount.spendSummary')}
                        Icon={IconApprovalDelegation}
                        href={getAbsoluteRoute('plan.summary')}
                    />
                </ConditionalComponent>

                <ConditionalComponent
                    condition={
                        favoritePharmacies.favoriteLocationIds.length > 0
                    }
                >
                    <SideNavLink
                        label={t('sidebar.myAccount.favoritePharmacies')}
                        Icon={IconFavorite}
                        href={getAbsoluteRoute('pharmacy.favorites')}
                    />
                </ConditionalComponent>
            </MenuSection>
        </ConditionalComponent>
    );
};
